<script setup lang="ts">
    import { defaultAutocompleteConverter } from "@/components/forms/inputs/Autocomplete/helpers";
    import { useStore } from "@/store";
    import { flashWarning } from "@/utils";

    const fetchVardformer = async ({ query }: { query?: string } = {}) => {
        const store = useStore();

        try {
            const params: { q?: string } = {};

            if (query) {
                params.q = query;
            }

            const { subsetName } = await store.dispatch("operation/vardform/fetchVardformer", {
                filterParams: params,
                displayMode: true,
            });

            return store.getters["operation/vardform/vardformSubset"]({ subsetName, displayMode: true });
        } catch (error) {
            flashWarning("Kunde inte hämta vårdformer");
        }
    };
</script>

<template>
    <KAutocomplete
        name="planerad_vardform"
        label="Planerad vårdform"
        v-bind="$attrs"
        :options="fetchVardformer"
        :onSearch="fetchVardformer"
        :converter="defaultAutocompleteConverter"
    />
</template>

<style lang="scss" scoped></style>
